module.exports = __webpack_public_path__ + "img/badge_viaggi.c193b1d8.jpg";